/**
 * Shared navigation route definitions consumed by SaasSidebar and CommandPalette.
 * Single source of truth — both components import from here.
 */

import {
  Camera,
  LayoutDashboard,
  Settings,
  Users,
  FolderOpen,
  Activity,
  FlaskConical,
  PenTool,
  ScrollText,
  SmartphoneNfc,
  Video,
  SlidersHorizontal,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface NavRoute {
  /** i18n key in common namespace, or a literal string if not translatable */
  labelKey: string
  /** literal string override — used when labelKey is not a real i18n key */
  labelLiteral?: string
  href: string
  Icon: LucideIcon
  /** When true, route is only visible to superusers */
  superuserOnly?: boolean
}

/** Main nav — visible to all authenticated users */
export const MAIN_NAV_ROUTES: NavRoute[] = [
  { labelKey: 'nav.dashboard', href: '/', Icon: LayoutDashboard },
  { labelKey: 'nav.cameras', href: '/cameras', Icon: Camera },
  { labelKey: 'nav.events', href: '/events', Icon: Activity },
  { labelKey: 'nav.groups', href: '/groups', Icon: FolderOpen },
]

/** Admin nav — superuser only (each entry has superuserOnly: true) */
export const ADMIN_NAV_ROUTES: NavRoute[] = [
  { labelKey: '', labelLiteral: 'All Cameras', href: '/all-cameras', Icon: Video, superuserOnly: true },
  { labelKey: 'sidebar.detectionAccuracy', href: '/detection-accuracy', Icon: SlidersHorizontal, superuserOnly: true },
  { labelKey: 'nav.users', href: '/users', Icon: Users, superuserOnly: true },
  { labelKey: 'nav.testCameras', href: '/test-cameras', Icon: FlaskConical, superuserOnly: true },
  { labelKey: 'nav.annotations', href: '/annotations', Icon: PenTool, superuserOnly: true },
  { labelKey: 'nav.cameraLogs', href: '/camera-logs', Icon: ScrollText, superuserOnly: true },
  { labelKey: '', labelLiteral: 'SIM mismatches', href: '/sim-mismatches', Icon: SmartphoneNfc, superuserOnly: true },
]

/** Settings nav — visible to all authenticated users, rendered at bottom of admin section */
export const SETTINGS_NAV_ROUTE: NavRoute = {
  labelKey: 'nav.settings',
  href: '/settings',
  Icon: Settings,
}
